import { render, staticRenderFns } from "./DatosDeudorOAcreedor.vue?vue&type=template&id=2d44346d&scoped=true&"
import script from "./DatosDeudorOAcreedor.vue?vue&type=script&lang=js&"
export * from "./DatosDeudorOAcreedor.vue?vue&type=script&lang=js&"
import style0 from "./DatosDeudorOAcreedor.vue?vue&type=style&index=0&id=2d44346d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d44346d",
  null
  
)

export default component.exports